import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { CalendarDate } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import React from "react";
import { VisitRow } from "./agenda-hard-landscape";

interface AgendaAwaitingOutcomeProps {
    visitsEnabled: boolean;
}

export const AgendaAwaitingOutcome: React.FC<AgendaAwaitingOutcomeProps> = ({
    visitsEnabled,
}) => {
    const trpcClient = trpc.useTRPC();
    const beforeDate = CalendarDate.fromLocalDate(new Date()).toString();

    const query = useQuery({
        ...trpcClient.calendarEvents.listAwaitingOutcome.queryOptions({ beforeDate }),
        enabled: visitsEnabled,
    });

    const visits = query.data ?? [];
    if (visits.length === 0) {
        return null;
    }

    return (
        <div className="overflow-hidden rounded-lg bg-white ring-1 ring-gray-300">
            <div className="flex items-center gap-2 border-b border-gray-200 px-4 py-3">
                <span className="h-5 w-1 flex-shrink-0 rounded-full bg-amber-500" />
                <ClipboardDocumentListIcon className="h-4 w-4 flex-shrink-0 text-gray-600" />
                <span className="text-sm font-semibold text-gray-800">
                    Awaiting outcome
                </span>
                <span className="text-xs text-gray-500">{visits.length}</span>
            </div>
            <ul className="divide-y divide-gray-100">
                {visits.map(visit => (
                    <VisitRow
                        key={visit.id}
                        visit={visit}
                        onMarked={() => query.refetch()}
                    />
                ))}
            </ul>
        </div>
    );
};
